import createNavItemsViewModel from '@qpr/components/Expandable/nav-items-view-model';
import React, { useContext, useEffect } from 'react';
import AppBarContext from '../components/BusinessPortalAppBarContext';
import LandingPageView from '../modules/LandingPage/views/LandingPageView';

const LandingPage = () => {
  const viewmodel = createNavItemsViewModel();
  const appBarContext = useContext(AppBarContext);

  useEffect(() => {
    appBarContext.setAppBar(false);
    appBarContext.setPeriodSelector(false);
  }, [appBarContext]);

  return <LandingPageView navItemsViewModel={viewmodel} />;
};

export default LandingPage;
